"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MediaParameters = _interopRequireDefault(require("../../../../models/dao/MediaParameters"));

var _TitleCollection = _interopRequireDefault(require("./models/TitleCollection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MediaInterface =
/*#__PURE__*/
function () {
  function MediaInterface() {
    _classCallCheck(this, MediaInterface);

    _.extend(this, Backbone.Events);

    this.items = new _TitleCollection["default"]();
    this.facets = {};
    this.sortOptions = [];
  }

  _createClass(MediaInterface, [{
    key: "quickSearch",
    value: function quickSearch(term, options) {
      return this._fetch(_.extend({}, {
        query: term
      }, options));
    }
  }, {
    key: "search",
    value: function search(parameters, options) {
      return this._fetch(_.extend({}, parameters, options));
    }
  }, {
    key: "fetchCollectionById",
    value: function fetchCollectionById(id, options) {
      return this._fetch(_.extend({}, {
        collectionId: id
      }, options));
    }
  }, {
    key: "fetchCollectionByParameters",
    value: function fetchCollectionByParameters(collectionFilters, options) {
      return this._fetch(_.extend({}, collectionFilters, options));
    }
    /** Utility function to simulate a data call, but deliberatley return an empty result set */

  }, {
    key: "fetchEmptyResponse",
    value: function fetchEmptyResponse() {
      this.trigger('sync:start', this, {
        mediaParameters: null
      });
      var emptyResponse = {
        items: [],
        facets: {},
        sortOptions: []
      };

      this._fetchDone(emptyResponse, 'synthetic');

      this.trigger('sync:end', this);
      return Promise.resolve(emptyResponse);
    }
    /**
     * @param {MediaParameters} parameters
     * @memberof MediaInterface
     */

  }, {
    key: "_fetch",
    value: function _fetch(parameters) {
      var _this = this;

      if (!parameters) {
        parameters = {};
      } // if a title id is specificed then no facets will be calculated regardless of the params sent.


      if (!parameters.includedFacets && !parameters.titleId) {
        parameters.includedFacets = window.OverDrive.supportedFacets;
      }

      if (window.featureManager.isEnabled('LuckyDay') && parameters.shuffle) {
        var sorts = ['mostpopular', 'releasedate', 'title', 'author', 'newlyadded', 'lowcirculating', 'mostpopular-site'];
        parameters.sortBy = sorts[Math.floor(Math.random() * sorts.length)];
      }

      var mediaParameters = new _MediaParameters["default"](parameters);

      if (!!window.OverDrive.showOnlyAvailable) {
        mediaParameters.showOnlyAvailable = true;
      }

      this.trigger('sync:start', this, {
        mediaParameters: mediaParameters
      });
      return new Promise(function (resolve, reject) {
        $.ajax({
          url: window.url(window.routes.rest.media.index),
          method: 'POST',
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          data: JSON.stringify(mediaParameters.serialize()),
          timeout: 10000
        }).done(function (data, textStatus, jqXHR) {
          if (window.featureManager.isEnabled('LuckyDay') && parameters.shuffle) {
            data.items = data.items && _.shuffle(data.items);
          }

          _this._fetchDone(data, textStatus, jqXHR);

          _this.trigger('sync:end', _this);

          resolve(data);
        }).fail(function (jqXHR, textStatus, errorThrown) {
          _this._fetchFail(jqXHR, textStatus, errorThrown);

          _this.trigger('sync:end', _this);

          reject(jqXHR);
        });
      });
    }
  }, {
    key: "_fetchDone",
    value: function _fetchDone(data, textStatus, jqXHR) {
      this.items.reset(data.items);
      this.trigger('sync:success', this, {
        data: data,
        textStatus: textStatus,
        jqXHR: jqXHR
      });
    }
  }, {
    key: "_fetchFail",
    value: function _fetchFail(jqXHR, textStatus, errorThrown) {
      this.trigger('sync:fail', this, {
        jqXHR: jqXHR,
        textStatus: textStatus,
        errorThrown: errorThrown
      });
    }
  }]);

  return MediaInterface;
}();

exports["default"] = MediaInterface;